import React, {useState} from "react";
import database from '../firebase';

const db = database.firestore();

export default function AlbumImgs(props) {
    const [ID] = useState(props.ID);
    const [ImgTitleid] = useState(props.title);
    const [id] = useState(props.id);
    const [image] = useState(props.image);
    const [Clear, setClear] = useState(props.Clear);

    const Delete =()=>{
        db.collection("users").doc(ID).collection("Album")
            .doc(ImgTitleid).collection("images").doc(id).delete().then(()=>{
            db.collection("users").doc(ID).collection("Album").doc(ImgTitleid).collection("images").get().then(querySnapshot=>{
                const data = querySnapshot.docs.map(doc=>doc.data());
                if(data.length===0){
                    db.collection("users").doc(ID).collection("Album").doc(ImgTitleid).delete().then(()=>{
                        setClear(true);
                    })
                }else{
                    setClear(true);
                }
            });
        })
    }

    if(Clear === true){
        return(
            <>
            </>
        )
    }else {
        return (
        <div className="AlbumUser-img_">
            <img src={image} alt=""/>
            <button onClick={Delete}>Delete <br/> 删除</button>
        </div>
        )
    }
    
}